export function init() {
    const accordionToggle = document.querySelectorAll('details.wp-block-details.is-style-plus')

    const setupAccordionToggle = function(details) {
        details.addEventListener('toggle', function(event) {
            if (!(event.target).open) {
                return;
            }
            details.querySelector('input')?.focus()
        })
    }

    accordionToggle.forEach(setupAccordionToggle)
}
